var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dw-survey-dcs-wrapper',{attrs:{"id":_vm.id,"is-answer-url":"true"},scopedSlots:_vm._u([{key:"dw-dcs-main-slot",fn:function(ref){
var survey = ref.survey;
return [(survey)?_c('dw-answer-url-main',{attrs:{"survey":survey}}):_vm._e()]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6055c010","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dw-survey/dw-collect/DwAnswerUrl.vue
// module id = null
// module chunks = 